import { render, staticRenderFns } from "./CaregiverApp.vue?vue&type=template&id=5582ba45&scoped=true&"
import script from "./CaregiverApp.vue?vue&type=script&lang=js&"
export * from "./CaregiverApp.vue?vue&type=script&lang=js&"
import style0 from "./CaregiverApp.vue?vue&type=style&index=0&id=5582ba45&scoped=true&lang=css&"
import style1 from "./CaregiverApp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5582ba45",
  null
  
)

export default component.exports